import TigerBugsnag from '@tiger/bugsnag';
import { toJS } from 'mobx';
import pkg from 'package.json';
import security from 'stores/security';
import UI from 'stores/ui';
import ignores from './ignore';

const { ErrorBoundary } = TigerBugsnag({
    apiKey: pkg.bugsnag,
    extraEnv: UI,
    // shouldReport: true,
    getCurrentUser: () => {
        const currentUser = security.currentUser;

        if (currentUser) {
            // 上报用户信息
            return toJS(currentUser);
        }

        return;
    },
    ignoreRules: ignores,
    redactedKeys: ['tax_identification_number', 'home_address', 'first_name', 'last_name', 'username']
});

export { ErrorBoundary };
